import CadastroDeAporte from "@/components/aportes/CadastroDeAporte";
import ListaDeAportes from "@/components/aportes/ListaDeAportes";
import CadastroDeAporteParaMcmvCidades from "@/components/aportes/mcmv-cidades/CadastroDeAporte";
import ListaDeAssinantes from "@/components/assinantes/ListaDeAssinantes";
import DetalhesDaSolicitacao from "@/components/controle-de-solicitacoes/detalhes-da-solicitacao/DetalhesDaSolicitacao";
import ListaDeSolicitacoes from "@/components/controle-de-solicitacoes/ListaDeSolicitacoes";
import DetalhesDaSolicitacaoParaMcmvCidades from "@/components/controle-de-solicitacoes/mcmv-cidades/DetalhesDaSolicitacaoParaMcmvCidades";
import ListaDeSolicitacoesParaGerenciamentoDoContrato from "@/components/controle-de-solicitacoes/mcmv-cidades/ListaDeSolicitacoesParaGerenciamentoDoContrato";
import ListaDeValidacaoDeMinutas from "@/components/controle-de-solicitacoes/mcmv-cidades/ListaDeValidacaoDeMinutas";
import ValidacaoDeMinuta from "@/components/controle-de-solicitacoes/mcmv-cidades/ValidacaoDeMinuta";
import Dashboard from "@/components/dashboard/Dashboard";
import Email from "@/components/email/Email";
import CadastrarEmpreendimento from "@/components/empreendimentos/CadastrarEmpreendimento";
import EditarEmpreendimento from "@/components/empreendimentos/EditarEmpreendimento";
import ListaDeEmpreendimentos from "@/components/empreendimentos/ListaDeEmpreendimentos";
import VisualizarEmpreendimento from "@/components/empreendimentos/VisualizarEmpreendimento";
import CadastrarCota from "@/components/gestao-de-cotas/CadastrarCota";
import EditarCota from "@/components/gestao-de-cotas/EditarCota";
import ListaDeCotas from "@/components/gestao-de-cotas/ListaDeCotas";
import VisualizarCota from "@/components/gestao-de-cotas/VisualizarCota";
import Layout from "@/components/layouts/Layout";
import LoginSeguranca from "@/components/login-seguranca/Login";
import GerarRelatorioDeSolicitacao from "@/components/relatorios/GerarRelatorioDeSolicitacao";
import SelecaoDeProjetoDeSubsidio from "@/components/selecao-de-projeto-de-subsidio/SelecaoDeProjetoDeSubsidio";
import SemPermissao from "@/components/sem-permissao/SemPermissao";
import ConsultaPorCpf from "@/components/solicitacao-de-subsidio/ConsultaPorCpf";
import EditarValoresDaSolicitacao from "@/components/solicitacao-de-subsidio/EditarValoresDaSolicitacao";
import FormularioDeSolicitacao from "@/components/solicitacao-de-subsidio/FormularioDeSolicitacao";
import ConsultaPorCpfParaMcmvCidades from "@/components/solicitacao-de-subsidio/McmvCidades/ConsultaPorCpfParaMcmvCidades";
import EditarValoresDaSolicitacaoParaMcmvCidades from "@/components/solicitacao-de-subsidio/McmvCidades/EditarValoresDaSolicitacaoParaMcmvCidades";
import FormularioDeSolicitacaoParaMcmvCidades from "@/components/solicitacao-de-subsidio/McmvCidades/FormularioDeSolicitacaoParaMcmvCidades";
import VisualizarSolicitacaoMcmv from "@/components/solicitacao-de-subsidio/McmvCidades/VisualizarSolicitacaoMcmv";
import VisualizarSolicitacao from "@/components/solicitacao-de-subsidio/VisualizarSolicitacao";
import Usuario from "@/plugins/usuario";
import { obterMenuInicial } from '@/utils/menuDoSistema';
import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
Vue.use(Usuario);

const router = new Router({
  routes: [
    {
      path: "/login-seguranca",
      name: "LoginSeguranca",
      component: LoginSeguranca,
      meta: {
        tituloDaPagina: "AGEHAB - Controle de Saldo do projeto faixa 1,5",
        acessoAnonimo: true,
      },
    },
    {
      path: "/",
      component: Layout,
      meta: { tituloDaPagina: "Controle de Saldo" },
      children: [
        {
          path: 'consulta-por-cpf',
          name: "ConsultaPorCpf",
          component: ConsultaPorCpf,
          meta: {
            tituloDaPagina: "Solicitar Subsídio",
            permissoes: ["SolicitacaoDeSubsidio"],
          },
        },
        {
          path: "selecao-de-projeto-de-subsidio",
          name: "SelecaoDeProjetoDeSubsidio",
          component: SelecaoDeProjetoDeSubsidio,
          meta: {
            tituloDaPagina: "Solicitar Subsídio",
            permissoes: [
              "SolicitacaoDeSubsidio",
              "SolicitacaoDeSubsidioParaMcmvCidades",
            ],
          },
        },
        {
          path: "consulta-por-cpf-para-mcmv-cidades",
          name: "ConsultaPorCpfParaMcmvCidades",
          component: ConsultaPorCpfParaMcmvCidades,
          meta: {
            tituloDaPagina: "Solicitar Subsídio",
            permissoes: ["SolicitacaoDeSubsidioParaMcmvCidades"],
          },
        },
        {
          path: "email",
          name: "Email",
          component: Email,
          meta: {
            tituloDaPagina: "Email",
            permissoes: ["SolicitacaoDeSubsidio"],
          },
        },
        {
          path: "formulario-de-solicitacao/:projetoId?",
          name: "FormularioDeSolicitacao",
          component: FormularioDeSolicitacao,
          meta: {
            tituloDaPagina: "Solicitar Subsídio",
            permissoes: ["SolicitacaoDeSubsidio"],
          },
        },
        {
          path: "formulario-de-solicitacao-para-mcmv-cidades/:projetoId?",
          name: "FormularioDeSolicitacaoParaMcmvCidades",
          component: FormularioDeSolicitacaoParaMcmvCidades,
          meta: {
            tituloDaPagina: "Solicitar Subsídio",
            permissoes: ["SolicitacaoDeSubsidioParaMcmvCidades"],
          },
        },
        {
          path: "visualizar-solicitacao",
          name: "VisualizarSolicitacao",
          component: VisualizarSolicitacao,
          meta: {
            tituloDaPagina: "Visualizar solicitação",
            permissoes: ["SolicitacaoDeSubsidio"],
          },
        },
        {
          path: "visualizar-solicitacao-mcmv",
          name: "VisualizarSolicitacaoMcmv",
          component: VisualizarSolicitacaoMcmv,
          meta: {
            tituloDaPagina: "Visualizar solicitação",
            permissoes: ["SolicitacaoDeSubsidioParaMcmvCidades"],
          },
        },
        {
          path: "editar-solicitacao",
          name: "EditarValoresDaSolicitacao",
          component: EditarValoresDaSolicitacao,
          meta: {
            tituloDaPagina: "Editar valores da solicitação",
            permissoes: ["EditarValoresDoSubsidio"],
          },
        },
        {
          path: "editar-solicitacao-mcmv-cidades",
          name: "EditarValoresDaSolicitacaoParaMcmvCidades",
          component: EditarValoresDaSolicitacaoParaMcmvCidades,
          meta: {
            tituloDaPagina: "Resumo da solicitação",
            permissoes: ["EditarValoresDoSubsidio"],
          },
        },
        {
          path: "dashboard",
          name: "Dashboard",
          component: Dashboard,
          meta: {
            tituloDaPagina: "Acompanhamento de saldo",
            permissoes: ["AcompanhamentoDoSaldo"],
          },
        },
        {
          path: "lista-de-solicitacoes",
          name: "ListaDeSolicitacoes",
          component: ListaDeSolicitacoes,
          meta: {
            tituloDaPagina: "Todas as solicitações",
            permissoes: ["VisualizarSolicitacoes"],
          },
        },
        {
          path: "lista-de-validacao-de-minuta",
          name: "ListaDeValidacaoDeMinutas",
          component: ListaDeValidacaoDeMinutas,
          meta: {
            tituloDaPagina: "Minutas",
            permissoes: ["ValidacaoDeMinutasDoMcmvCidades"],
          },
        },
        {
          path: "detalhes-da-solicitacao",
          name: "DetalhesDaSolicitacao",
          component: DetalhesDaSolicitacao,
          meta: {
            tituloDaPagina: "Resumo da solicitação",
            permissoes: ["VisualizarSolicitacoes"],
          },
        },
        {
          path: "detalhes-da-solicitacao-mcmv-cidades",
          name: "DetalhesDaSolicitacaoParaMcmvCidades",
          component: DetalhesDaSolicitacaoParaMcmvCidades,
          meta: {
            tituloDaPagina: "Resumo da solicitação do Mcmv Cidades",
            permissoes: ["VisualizarSolicitacoes"],
          },
        },
        {
          path: "validacao-de-minuta-mcmv-cidades",
          name: "ValidacaoDeMinuta",
          component: ValidacaoDeMinuta,
          meta: {
            tituloDaPagina: "Validação de minuta",
            permissoes: ["ValidacaoDeMinutasDoMcmvCidades"],
          },
        },
        {
          path: "lista-de-empreendimentos",
          name: "ListaDeEmpreendimentos",
          component: ListaDeEmpreendimentos,
          meta: {
            tituloDaPagina: "Todos os empreendimentos",
            permissoes: ["GerenciarEmprendimento"],
          },
        },
        {
          path: "cadastrar-empreendimento",
          name: "CadastrarEmpreendimento",
          component: CadastrarEmpreendimento,
          meta: {
            tituloDaPagina: "Cadastro de empreendimento",
            permissoes: ["GerenciarEmprendimento"],
          },
        },
        {
          path: "editar-empreendimento",
          name: "EditarEmpreendimento",
          component: EditarEmpreendimento,
          meta: {
            tituloDaPagina: "Editar de empreendimento",
            permissoes: ["GerenciarEmprendimento"],
          },
        },
        {
          path: "visualizar-empreendimento",
          name: "VisualizarEmpreendimento",
          component: VisualizarEmpreendimento,
          meta: {
            tituloDaPagina: "Visualização de empreendimento",
            permissoes: ["GerenciarEmprendimento"],
          },
        },
        {
          path: "lista-de-aporte/:projetoId?",
          name: "ListaDeAportes",
          component: ListaDeAportes,
          meta: {
            tituloDaPagina: "Cadastro de aporte",
            permissoes: ["GerenciarDeposito"],
          },
        },
        {
          path: "cadastrar-aporte/:projetoId",
          name: "CadastroDeAporte",
          component: CadastroDeAporte,
          meta: {
            tituloDaPagina: "Cadastro de aporte",
            permissoes: ["GerenciarDeposito"],
          },
        },
        {
          path: "cadastrar-aporte-mcmv-cidades/:projetoId",
          name: "CadastroDeAporteMcmv",
          component: CadastroDeAporteParaMcmvCidades,
          meta: {
            tituloDaPagina: "Cadastro de aporte",
            permissoes: ["GerenciarDeposito"],
          },
        },
        {
          path: "gerar-relatorio-de-solicitacoes",
          name: "GerarRelatorioDeSolicitacao",
          component: GerarRelatorioDeSolicitacao,
          meta: {
            tituloDaPagina: "Relatório de Solicitações",
            permissoes: ["GerarRelatorioDeSolicitacoes"],
          },
        },
        {
          path: "lista-de-cotas",
          name: "ListaDeCotas",
          component: ListaDeCotas,
          meta: {
            tituloDaPagina: "Todas as cotas",
            permissoes: ["GerenciarCotas"],
          },
        },
        {
          path: "cadastrar-cota",
          name: "CadastrarCota",
          component: CadastrarCota,
          meta: {
            tituloDaPagina: "Cadastro de cota por cidade",
            permissoes: ["GerenciarCotas"],
          },
        },
        {
          path: "editar-cota",
          name: "EditarCota",
          component: EditarCota,
          meta: {
            tituloDaPagina: "Editar de cota de subsídio",
            permissoes: ["GerenciarCotas"],
          },
        },
        {
          path: "visualizar-cotas",
          name: "VisualizarCota",
          component: VisualizarCota,
          meta: {
            tituloDaPagina: "Visualização de cota de subsídio",
            permissoes: ["GerenciarCotas"],
          },
        },
        {
          path: "solicitacoes-para-gerenciamento-do-contrato",
          name: "ListaDeSolicitacoesParaGerenciamentoDoContrato",
          component: ListaDeSolicitacoesParaGerenciamentoDoContrato,
          meta: {
            tituloDaPagina: "Contratos",
            permissoes: ["GerenciarContratoDoMcmvCidades"],
          },
        },
        {
          path: "assinantes",
          name: "ListaDeAssinantes",
          component: ListaDeAssinantes,
          meta: {
            tituloDaPagina: "Assinantes",
            permissoes: ["GerenciarAssinantes"],
          },
        },
        {
          path: "sem-permissao",
          name: "SemPermissao",
          component: SemPermissao,
          meta: {
            tituloDaPagina: "Acesso negado",
            dispensaPermissao: true,
            ocultarBotaoVoltar: true,
          },
        },
      ],
    },
  ],
});

const vue = new Vue();

const possuiAlgumaDasPermissoes = permissoes =>
  permissoes.some(permissao => vue.$usuario.possuiPermissao(permissao));

router.beforeEach((route, redirect, next) => {
  window.scrollTo(0, 0);

  if (route.meta.acessoAnonimo) return next();
  if (vue.$usuario.estaLogado()) {
    if (route.path === "/") {
      const menuInicial = obterMenuInicial(vue.$usuario.possuiPermissao);
      if (menuInicial) return next({ name: menuInicial.link });

      return next({ path: "/sem-permissao" });
    }
    if (route.meta.dispensaPermissao) return next();
    if (possuiAlgumaDasPermissoes(route.meta.permissoes || [])) return next();

    return next({ path: "/" });
  }

  return next({ path: "/login-seguranca", query: { redirect: route.path } });
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js